export const ElementAutoHeight = {
  methods: {
    /**
     * @param {object} elem
     */
    setElementAutoHeight (elem) {
      if (!elem) {
        return
      }

      elem.style.height = 'auto'
      elem.style.height = `${elem.scrollHeight}px`
    }
  }
}
